import {
  CAROUSEL_ITEMS,
  CLICK_THROUGH_LINK,
  FORMAT_CAROUSEL,
  FORMAT_OPTION,
  FORMAT_SINGLE,
  FORMAT_STORY,
  STORIES_ITEMS,
  UTM_CODES_LIST
} from '../../../fields'
import { PAGE_LIKES } from '../../../../../../constants/reusableObjectives'

export default function getShowUrlTagsStep(values, lineItemObjective) {
  if (lineItemObjective === PAGE_LIKES) {
    // do not show URL TAGS step for line items with objective "page_likes"
    return false
  }

  const formatOption = values[FORMAT_OPTION]

  let clickThroughLinkContainsUtmCode = false

  if (formatOption === FORMAT_SINGLE) {
    const clickThroughLink = values[CLICK_THROUGH_LINK]
    clickThroughLinkContainsUtmCode = UTM_CODES_LIST.some(item => clickThroughLink.includes(item))
  }

  if (formatOption === FORMAT_CAROUSEL) {
    const carouselItems = values[CAROUSEL_ITEMS]

    clickThroughLinkContainsUtmCode = carouselItems.some(carouselItem => {
      const carouselItemLink = carouselItem[CLICK_THROUGH_LINK]

      return UTM_CODES_LIST.some(item => carouselItemLink.includes(item))
    })
  }

  if (formatOption === FORMAT_STORY) {
    const storyItems = values[STORIES_ITEMS]

    clickThroughLinkContainsUtmCode = storyItems.some(storyItem => {
      const storyItemLink = storyItem[CLICK_THROUGH_LINK]

      return UTM_CODES_LIST.some(item => storyItemLink.includes(item))
    })
  }

  // Show URL TAGS step only if click through link doesn't contain any utm code
  return !clickThroughLinkContainsUtmCode
}
